import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Slider from 'react-slick'

import {
  CarouselContainer,
  VerticalContainer,
  DotsContainer,
  CarouselDot,
  DotsCounter,
  DotsWrapper
} from '../PartnerServiceOffer.style'

export const carouselSettings = {
  infinite: false,
  dots: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  variableWidth: true,
  customPaging: () => <CarouselDot />
}

const MobileCarousel = ({ data, bookLabel, village, mapServiceCard }) => {
  const [currentIndex, setCurrentIndex] = useState(1)

  if(data.length <= 4) {
    return (
      <VerticalContainer>
        {data.map((item) => mapServiceCard(item, bookLabel, village, true))}
      </VerticalContainer>
    )
  }

  return (
    <CarouselContainer isMobile>
      <Slider
        {...carouselSettings}
        afterChange={(current) => setCurrentIndex(current + 1)}
        initialSlide={currentIndex - 1}
        customPaging={() => <CarouselDot />}
        appendDots={dots => (
          <DotsContainer>
            <DotsCounter>{currentIndex} of {data.length}</DotsCounter>
            <DotsWrapper totalCount={data.length}>{dots}</DotsWrapper>
          </DotsContainer>
        )}
      >
        {data.map((item) => mapServiceCard(item, bookLabel, village))}
      </Slider>
    </CarouselContainer>
  )
}

MobileCarousel.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array]),
  bookLabel: PropTypes.string,
  village: PropTypes.string,
  mapServiceCard: PropTypes.func,
}

MobileCarousel.defaultProps = {
  data: [],
  bookLabel: '',
  village: 'Bicester Village',
  mapServiceCard: () => null
}

export default MobileCarousel